// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2pKwz","title":"AfterFrontImage_title__2xgpc"};